import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { OrderRow } from '../types';

const QUERY_KEY = 'payments';

export const getPayments = (organizerId: number): Promise<OrderRow[]> => {
  return axios.get(`/payment/all/${organizerId}`);
};

type QueryFnType = typeof getPayments;

type UseOptions = {
  organizerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const usePayments = ({ config, organizerId }: UseOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [QUERY_KEY, organizerId],
    queryFn: () => getPayments(organizerId),
    ...config,
  });
};
